import { g as s } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as n, openBlock as l, normalizeClass as r, createElementVNode as e } from "vue";
import { _ as d } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconFront",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (t) => Object.keys(i).includes(t)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = s();
  }
}, u = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5.223 5.45a3.302 3.302 0 0 1 3.302-3.302h10.59v4.7a1.65 1.65 0 0 1-1.65 1.651h-4.33a1.588 1.588 0 0 0-1.561 1.566v10.279c0 .912-.74 1.65-1.651 1.65h-4.7V5.452z",
  fill: "#001B38"
}, null, -1), p = ["fill"], h = ["fill"], f = ["id"], m = /* @__PURE__ */ e("stop", {
  "stop-color": "#FF0057",
  "stop-opacity": ".16"
}, null, -1), g = /* @__PURE__ */ e("stop", {
  offset: ".861",
  "stop-color": "#FF0057"
}, null, -1), F = [
  m,
  g
], I = ["id"], y = /* @__PURE__ */ e("stop", {
  "stop-color": "#FF0057",
  "stop-opacity": ".16"
}, null, -1), b = /* @__PURE__ */ e("stop", {
  offset: ".861",
  "stop-color": "#FF0057"
}, null, -1), q = [
  y,
  b
];
function v(t, S, o, z, D, a) {
  return l(), n("svg", {
    "aria-label": o.ariaLabel,
    class: r([a.iconSizeClass, "d-icon d-icon--front"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Front",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _,
    e("path", {
      d: "M8.914 10.127a4.287 4.287 0 1 0 8.574 0 4.287 4.287 0 0 0-8.574 0z",
      fill: `url(#${t.uniqueID}a)`
    }, null, 8, p),
    e("path", {
      opacity: ".5",
      d: "M8.914 10.127a4.287 4.287 0 1 0 8.574 0 4.287 4.287 0 0 0-8.574 0z",
      fill: `url(#${t.uniqueID}b)`
    }, null, 8, h),
    e("defs", null, [
      e("linearGradient", {
        id: `${t.uniqueID}a`,
        x1: "10.182",
        y1: "6.913",
        x2: "16.629",
        y2: "13.404",
        gradientUnits: "userSpaceOnUse"
      }, F, 8, f),
      e("linearGradient", {
        id: `${t.uniqueID}b`,
        x1: "10.182",
        y1: "6.913",
        x2: "16.629",
        y2: "13.404",
        gradientUnits: "userSpaceOnUse"
      }, q, 8, I)
    ])
  ], 10, u);
}
const U = /* @__PURE__ */ d(c, [["render", v]]);
export {
  U as default
};
//# sourceMappingURL=front.js.map
